import {useAuth} from 'app/modules/auth'
import {GetCustomMenu} from 'app/services/commonService'
import {ErrorHandler} from 'app/shared/Alfacom/ErrorHandler/ErrorHandler'
import {GetModuleColor, GetModuleIcon, GetModulePath, GetModuleText, Group, Module, Role} from 'app/shared/Common/Enums'
import {HasPermissionInGroup, HasPermissionInRole} from 'app/shared/Common/Util'
import {useEffect, useState} from 'react'
import {useIntl} from 'react-intl'
import {AsideMenuItem} from './AsideMenuItem'
import {AsideMenuItemWithSub} from './AsideMenuItemWithSub'
import {AsideMenuSub} from './AsideMenuSub'

export function AsideMenuMain() {
  const {currentUser} = useAuth()
  const intl = useIntl()
  const [customMenuTitle, setCustomMenuTitle] = useState<string>()
  const [customMenuIcon, setCustomMenuIcon] = useState<string>('far fa-question-circle')
  const [customSubMenu, setCustomSubMenu] = useState<any>([])

  useEffect(() => {
    loadCustomMenu()
  }, [])

  function loadCustomMenu() {
    if (currentUser) {
      GetCustomMenu()
        .then((respond: any) => {
          if (respond.status == 200) {
            setCustomMenuTitle(respond.data.menuTitle)
            if (respond.data.menuIcon && respond.data.menuIcon.length > 0) setCustomMenuIcon(respond.data.menuIcon)
            setCustomSubMenu(respond.data.subMenus)
          } else {
            console.error(`Error - Loading Custom Menu. Message: ${respond.data.message}`)
          }
        })
        .catch((error) => {
          ErrorHandler(error)
        })
    }
  }

  return (
    <>
      <div className='d-flex flex-column align-items-center align-items-lg-start gap-4'>
        {HasPermissionInRole(currentUser, [Role.INT_Report_Full, Role.INT_Report_Read]) && (
          <AsideMenuItem
            to={GetModulePath(Module.Dashboard)}
            variant={GetModuleColor(Module.Dashboard)}
            biIcon={GetModuleIcon(Module.Dashboard)}
            title={GetModuleText(Module.Dashboard)}
          />
        )}

        {HasPermissionInRole(currentUser, [Role.INT_System]) && (
          <AsideMenuItem
            to={GetModulePath(Module.Administration)}
            variant={GetModuleColor(Module.Administration)}
            biIcon={GetModuleIcon(Module.Administration)}
            title={GetModuleText(Module.Administration)}
          />
        )}

        {HasPermissionInRole(currentUser, [Role.INT_User_Full, Role.INT_User_Read]) && (
          <AsideMenuItem
            to={GetModulePath(Module.Secretariats)}
            variant={GetModuleColor(Module.Secretariats)}
            faIcon={GetModuleIcon(Module.Secretariats)}
            title={GetModuleText(Module.Secretariats)}
          />
        )}

        {HasPermissionInRole(currentUser, [Role.INT_Profile_Full, Role.INT_Profile_Read]) && (
          <AsideMenuItem
            to={GetModulePath(Module.MembersAndPartners)}
            variant={GetModuleColor(Module.MembersAndPartners)}
            faIcon={GetModuleIcon(Module.MembersAndPartners)}
            title={GetModuleText(Module.MembersAndPartners)}
          />
        )}

        {HasPermissionInRole(currentUser, [Role.INT_Submission_Full, Role.INT_Submission_Read]) && (
          <AsideMenuItemWithSub
            to={GetModulePath(Module.Program)}
            variant={GetModuleColor(Module.Program)}
            image={GetModuleIcon(Module.Program)}
            title={GetModuleText(Module.Program)}
          >
            <AsideMenuSub
              column={12}
              to={GetModulePath(Module.Submission)}
              variant={GetModuleColor(Module.Submission)}
              faIcon={GetModuleIcon(Module.Submission)}
              title={GetModuleText(Module.Submission)}
            ></AsideMenuSub>
            <AsideMenuSub
              column={12}
              to={GetModulePath(Module.Pledge)}
              variant={GetModuleColor(Module.Pledge)}
              faIcon={GetModuleIcon(Module.Pledge)}
              title={GetModuleText(Module.Pledge)}
            ></AsideMenuSub>
          </AsideMenuItemWithSub>
        )}

        {HasPermissionInRole(currentUser, [Role.INT_Announcement_Full, Role.INT_Announcement_Read]) && (
          <AsideMenuItem
            to={GetModulePath(Module.Announcements)}
            variant={GetModuleColor(Module.Announcements)}
            biIcon={GetModuleIcon(Module.Announcements)}
            title={GetModuleText(Module.Announcements)}
          />
        )}

        {HasPermissionInRole(currentUser, [Role.INT_Report_Full, Role.INT_Report_Read]) && (
          <AsideMenuItem
            to={GetModulePath(Module.Reports)}
            variant={GetModuleColor(Module.Reports)}
            biIcon={GetModuleIcon(Module.Reports)}
            title={GetModuleText(Module.Reports)}
          />
        )}

        {HasPermissionInRole(currentUser, [Role.INT_System, Role.INT_Maintenance_Full, Role.INT_Maintenance_Read]) && (
          <AsideMenuItemWithSub
            to={GetModulePath(Module.Maintenance)}
            variant={GetModuleColor(Module.Maintenance)}
            biIcon={GetModuleIcon(Module.Maintenance)}
            title={GetModuleText(Module.Maintenance)}
          >
            {HasPermissionInRole(currentUser, [Role.INT_System]) && (
              <AsideMenuSub
                column={12}
                to={GetModulePath(Module.Permission)}
                variant={GetModuleColor(Module.Permission)}
                faIcon={GetModuleIcon(Module.Permission)}
                title={GetModuleText(Module.Permission)}
              ></AsideMenuSub>
            )}
            {HasPermissionInRole(currentUser, [Role.INT_Maintenance_Full, Role.INT_Maintenance_Read]) && (
              <AsideMenuItemWithSub
                column={12}
                to={GetModulePath(Module.Maintenance_List)}
                variant={GetModuleColor(Module.Maintenance_List)}
                biIcon={GetModuleIcon(Module.Maintenance_List)}
                title={GetModuleText(Module.Maintenance_List)}
                width={175}
                widthLg={200}
              >
                <AsideMenuSub
                  column={12}
                  to={GetModulePath(Module.Maintenance_List_Cluster)}
                  variant={GetModuleColor(Module.Maintenance_List_Cluster)}
                  title={GetModuleText(Module.Maintenance_List_Cluster)}
                  textAlign='left'
                ></AsideMenuSub>
                <AsideMenuSub
                  column={12}
                  to={GetModulePath(Module.Maintenance_List_InterventionType)}
                  variant={GetModuleColor(Module.Maintenance_List_InterventionType)}
                  title={GetModuleText(Module.Maintenance_List_InterventionType)}
                  textAlign='left'
                ></AsideMenuSub>
                <AsideMenuSub
                  column={12}
                  to={GetModulePath(Module.Maintenance_List_BeneficiaryType)}
                  variant={GetModuleColor(Module.Maintenance_List_BeneficiaryType)}
                  title={GetModuleText(Module.Maintenance_List_BeneficiaryType)}
                  textAlign='left'
                ></AsideMenuSub>
                <AsideMenuSub
                  column={12}
                  to={GetModulePath(Module.Maintenance_List_ContributionType)}
                  variant={GetModuleColor(Module.Maintenance_List_ContributionType)}
                  title={GetModuleText(Module.Maintenance_List_ContributionType)}
                  textAlign='left'
                ></AsideMenuSub>
                <AsideMenuSub
                  column={12}
                  to={GetModulePath(Module.Maintenance_List_Country)}
                  variant={GetModuleColor(Module.Maintenance_List_Country)}
                  title={GetModuleText(Module.Maintenance_List_Country)}
                  textAlign='left'
                ></AsideMenuSub>
                <AsideMenuSub
                  column={12}
                  to={GetModulePath(Module.Maintenance_List_State)}
                  variant={GetModuleColor(Module.Maintenance_List_State)}
                  title={GetModuleText(Module.Maintenance_List_State)}
                  textAlign='left'
                ></AsideMenuSub>
                <AsideMenuSub
                  column={12}
                  to={GetModulePath(Module.Maintenance_List_District)}
                  variant={GetModuleColor(Module.Maintenance_List_District)}
                  title={GetModuleText(Module.Maintenance_List_District)}
                  textAlign='left'
                ></AsideMenuSub>
                <AsideMenuSub
                  column={12}
                  to={GetModulePath(Module.Maintenance_List_Mukim)}
                  variant={GetModuleColor(Module.Maintenance_List_Mukim)}
                  title={GetModuleText(Module.Maintenance_List_Mukim)}
                  textAlign='left'
                ></AsideMenuSub>
                <AsideMenuSub
                  column={12}
                  to={GetModulePath(Module.Maintenance_List_SDG)}
                  variant={GetModuleColor(Module.Maintenance_List_SDG)}
                  title={GetModuleText(Module.Maintenance_List_SDG)}
                  textAlign='left'
                ></AsideMenuSub>
              </AsideMenuItemWithSub>
            )}
          </AsideMenuItemWithSub>
        )}

        {customSubMenu.length > 0 && (
          <>
            {customSubMenu.length === 1 && (
              <>
                {customSubMenu.map((menu: any, index: any) => {
                  var menuName = menu.Key
                  var fileName = menu.Value.split('.')[0]
                  return <AsideMenuItem biIcon={customMenuIcon} key={index} title={menuName} to={`/main/menu/${index}/${fileName}`} target='_blank' />
                })}
              </>
            )}
            {customSubMenu.length > 1 && (
              <AsideMenuItemWithSub to='#' variant='' biIcon={customMenuIcon} title={customMenuTitle!} width={200} widthLg={225}>
                <>
                  {customSubMenu.map((menu: any, index: any) => {
                    var menuName = menu.Key
                    var fileName = menu.Value.split('.')[0]
                    return (
                      <AsideMenuSub
                        column={12}
                        variant='dark'
                        key={index}
                        title={menuName}
                        to={`/main/menu/${index}/${fileName}`}
                        target='_blank'
                        textAlign='left'
                      />
                    )
                  })}
                </>
              </AsideMenuItemWithSub>
            )}
          </>
        )}
      </div>
    </>
  )
}
